import { screen, colors } from 'components/styles/variables';

interface BannerProps {
  bannerTitle?: string;
}

export default function Banner({ bannerTitle }: BannerProps): JSX.Element {
  return (
    <div className="banner-row">
      <div className="banner-container">
        <div className="banner-content">
          <div className="banner-title-wrapper">
            <h1 className="banner-title" data-heading={bannerTitle}>
              {bannerTitle}
            </h1>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .banner-title {
            font-size: 14px;
            line-height: 18px;
            font-weight: 600;
          }

          .banner-row {
            width: 100%;
            display: flex;
            justify-content: center;
            border-bottom: 1px solid ${colors.G2};
          }

          .banner-title-wrapper {
            max-width: 1392px;
            width: 100%;
          }

          .banner-container {
            margin-bottom: 1px;
            display: flex;
            flex-direction: column;
            font-weight: 700;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.2px;
            height: 52px;
            width: 100%;
            justify-content: center;
            padding-left: 16px;
          }

          .banner-content {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          @media (min-width: ${screen.mdMin}) {
            .banner-container {
              padding-left: 24px;
            }
            .banner-title {
              font-size: 18px;
              line-height: 22px;
              font-weight: bold;
            }
          }

          @media (min-width: ${screen.lgMin}) {
            .banner-container {
              padding-left: 0;
            }
          }
        `}
      </style>
    </div>
  );
}
